
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Naciśnij „Otwórz w przeglądarce…”`,
's182ab2d6c997515f': `Dodaj do swojego Ekranu Głównego, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
's224cbcec014ef6b5': `Wybierz "Udostępnij"`,
's233af3b7eb5e0364': `Dodaj do strony głównej`,
's37a9e8aec5713460': `Więcej`,
's4c3161035f3a1413': `Naciśnij Menu`,
's4e1e10a6ca408245': `Naciśnij "Dodaj do Ekranu Głównego"`,
's6196153c4b0c1ea0': `Zainstaluj`,
's633502f7cff4f847': `Otwórz menu przeglądarki`,
's681e399d63311fba': `Pokaż galerię`,
's6d14a4f70ba4e3cf': `Naciśnij Menu, jeśli brak ikony Udostępnij`,
's922329d6f6213590': `Dodaj do Docka`,
's9c63a79ffcc2a3a3': `Naciśnij "Dodaj do Ekranu Głównego"`,
'sa2d71bfd9525168d': `Naciśnij "Dodaj do Docka"`,
'sa5ef80b4bb9b39f8': `Mniej`,
'sb527eca1c1d7e7be': `Otwórz menu przeglądarki w aplikacji`,
'sba52286c21552a4e': `Zainstaluj na swoim urządzeniu, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sc16e00a7a8b2fde2': `Wstecz`,
'scdaf4bbff76674c8': `Dodaj do Ekranu Głównego`,
'sd18a5b85f599ff3c': `Otwórz skopiowany link w Safari`,
'se72fc3a84f9b51c3': `Naciśnij, aby skopiować link`,
'se740f75b95a51807': `Dodaj do swojego Docka, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sfa6c42cdf48d93d2': `Ta przeglądarka nie obsługuje jednak tej funkcji. Aby kontynuować, otwórz link w zewnętrznej przeglądarce.`,
'sfb78526365796a41': `Naciśnij "Wyświetl więcej" w menu Udostępnij`,
'sfea652f6580ff086': `Ta strona posiada funkcje aplikacji.`,
    };
  